import React from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import styles from './_privacyStyles.css'
import { routeActions } from 'react-router-redux'

const mapStateToProps = () => ({})

const mapDispatchToActions = {
  navigateTo: routeActions.push,
}

function BigLink (props) {
  /*
   * destination: for internal react navigation
   * href: for external pages
   */

  const { children, href, navigateTo, destination, analyticsEvent, screenName } = props

  return (
    <a
      className={styles.bigLink}
      onClick={ () => {
        if (destination) {
          navigateTo(destination)
        }
        if (analyticsEvent) {
          analyticsEvent(screenName)
        }
      } }
      href={ !destination && href ? href : null }
    >
      { children }
    </a>
  )
}

BigLink.propTypes = {
  children: PropTypes.object,
  href: PropTypes.string,
  navigateTo: PropTypes.func,
  destination: PropTypes.string,
  analyticsEvent: PropTypes.func,
  screenName: PropTypes.string,
}

export default connect(mapStateToProps, mapDispatchToActions)(BigLink)



// WEBPACK FOOTER //
// ./src/components/privacy_center/util/BigLink.jsx